import React from 'react';
import { Trans } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { bridge } from 'Helpers/bridge';
import { ReduxHOC } from 'HOC';
import { Auth } from 'Helpers';

const DefaultMobileFooter = ({ t }) => {
  const history = useHistory();
  const location = useLocation();
  // Footer navigation items
  const footerItems = [
    {
      id: 'home',
      icon: 'icon-home',
      title: 'HUB',
      path: '/games',
      disabled: false,
      public: true,
      customTrigger: () => {
        bridge.gotoGamesHub();
      },
    },
    {
      id: 'lobby',
      icon: 'icon-league',
      title: t('LOBBY'),
      path: '/',
      disabled: false,
      public: true,
      customTrigger: null,
    },
    {
      id: 'completed',
      icon: 'icon-stadium-ic',
      title: t('Completed'),
      path: '/completed-leagues',
      disabled: false,
      public: true,
      customTrigger: null,
    },
    {
      id: 'how-to-play',
      icon: 'icon-how-to-play',
      title: t('How To Play'),
      path: '/how-to-play',
      disabled: false,
      public: false,
      customTrigger: null,
    },
     
  ];

  // Check if current path matches footer item
  const isActivePath = (path) => {
    if (!location || !location.pathname) return false;
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  // Handle navigation
  const handleNavigation = (item) => {
    if (!item.public && !Auth.getAuth()) {
      bridge.signup();
      return;
    }
    if (item.disabled) return;
    if (item.customTrigger) {
      item.customTrigger(item);
      return;
    }

    if (item.path === '/') {
      history.push('/');
    } else {
      history.push(item.path);
    }
  };

  const shouldShowFooter = () => {
    if (!location || !location.pathname) return false;
    const showPaths = ['/', '/my-contests', '/completed-leagues', '/how-to-play', '/more'];
    return showPaths.some((path) => location.pathname === path);
  };

  if (!shouldShowFooter()) {
    return null;
  }

  return (
    <>
      <div className="default-sm-footer">
        {footerItems.map((item) => (
          <div
            key={item.id}
            className={`footer-link ${isActivePath(item.path) ? 'active' : ''} ${
              item.disabled ? 'disabled-navlink' : ''
            }`}
            onClick={() => handleNavigation(item)}
          >
            <i className={`link-icon ${item.icon}`}></i>
            <span className="link-title">
              <Trans>{item.title}</Trans>
            </span>
          </div>
        ))}
      </div>
      <div className="footer-space" />
    </>
  );
};

export default ReduxHOC(DefaultMobileFooter);
